import { useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { selectIsOnline, selectIsProcoreDesign } from "slices/explorer";

/**
 * Which no-internet-connection bar (if any) should be shown.
 *
 * - `"synced"`: the model is fully downloaded for offline use (`view.data` is
 *   available), so being offline is expected and only a subtle chip is shown.
 * - `"intermittent"`: the model is not fully synced, so losing connection means
 *   some features won't work — a prominent full-width bar is shown.
 * - `null`: online, or no offline indicator applies for this UX.
 */
export type OfflineBarVariant = "synced" | "intermittent" | null;

export function useOfflineBarVariant(): OfflineBarVariant {
    const isOnline = useAppSelector(selectIsOnline);
    const isProcoreDesign = useAppSelector(selectIsProcoreDesign);
    const {
        state: { view },
    } = useExplorerGlobals();

    if (isOnline || !isProcoreDesign) {
        return null;
    }

    return view?.data ? "synced" : "intermittent";
}
